__turbopack_context__.v({
  "inner": "TextMask-module__vH7eQG__inner",
  "rect": "TextMask-module__vH7eQG__rect",
  "root": "TextMask-module__vH7eQG__root",
  "svg": "TextMask-module__vH7eQG__svg",
  "text": "TextMask-module__vH7eQG__text",
});
